/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const HddIconConfig = {
  name: 'HddIcon',
  height: 512,
  width: 576,
  svgPath: 'M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(HddIconConfig);
//# sourceMappingURL=hdd-icon.js.map